import useAuthStore from '../../../stores/authStore';
import NavTargetLink from './NavTargetLink';
import NavUserMenu from './NavUserMenu';
import { LOGIN_LINK } from './navigationConfig';

function ExternalLinkIcon() {
  return (
    <svg
      className="c-button-outlined__icon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14 3h7v7M10 14L21 3M21 14v7h-7M3 10V3h7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function NavAuthButton({ onNavigate }) {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <NavUserMenu onNavigate={onNavigate} />;
  }

  return (
    <div className="c-nav-auth">
      <NavTargetLink target={LOGIN_LINK} className="c-button-outlined w-button" onNavigate={onNavigate}>
        <span>{LOGIN_LINK.label}</span>
        <ExternalLinkIcon />
      </NavTargetLink>
    </div>
  );
}

export default NavAuthButton;
